import { STRENGTH_DOMAIN, POSTURE_DOMAIN, ANATOMY_DOMAIN, YOGA_DOMAIN } from 'verticalConfigs';

const KEYSCOMBINATIONS = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
];

const KEYSCOMBINATIONSSECOND = [
  'q',
  'w',
  'e',
  'r',
  't',
  'y',
  '0',
  '0',
  '0',
  '0',
  '0',
  'y',
  't',
  'r',
  'e',
  'w',
  'q',
  '0',
  '0',
  '0',
  '0',
  '0',
];

export const SETOFKEYS = KEYSCOMBINATIONS.join('');
export const LENGTHOFKEYS = KEYSCOMBINATIONS.length;

export const SETOFKEYSSECOND = KEYSCOMBINATIONSSECOND.join('');
export const LENGTHOFKEYSSECOND = KEYSCOMBINATIONSSECOND.length;

export const VERTICAL_ITEMS = [
  { label: 'Strength Training', link: STRENGTH_DOMAIN },
  { label: 'Posture', link: POSTURE_DOMAIN },
  { label: 'Anatomy', link: ANATOMY_DOMAIN },
  { label: 'Yoga', link: YOGA_DOMAIN },
];
export const BROWSERS = [
  { name: 'Chrome/', allowed: true },
  { name: 'Firefox/', allowed: true },
  { name: 'Opera/', allowed: true },
  { name: 'Safari/', allowed: true },
  { name: 'Edge/', allowed: true },
  { name: 'MSIE/', allowed: false },
  { name: 'Trident/', allowed: false },
];
